import ViewBase from "../../../../framework/core/mvvm/view_base";
import AppData from "../../const/app_data";
import { GameManager } from "../../../../manager/game_manager";


const {ccclass, property} = cc._decorator;

@ccclass
export default class LoadingView extends ViewBase {


    @property(cc.ProgressBar)
    public progressBar : cc.ProgressBar = null;

    @property(cc.Node)
    public barRightNode : cc.Node = null;

    @property(cc.Label)
    public textLabel : cc.Label = null;

    @property(cc.Label)
    public versionLabel : cc.Label = null;

    onLoad()
    {
        //this.startProgress();
        //this.barRightNode.active = false;

    }
    onShow()
    {
        super.onShow();        

        if (cc.sys.isNative) {
            this.showTextLabel( "การตรวจสอบเวอร์ชัน ...");     
        } else {
            //版本检测中...请稍后
            this.showTextLabel( "การตรวจสอบเวอร์ชัน ...");  
        }
        this.versionLabel.string = GameManager.getAppAssetVersion();
        this.progressBar.totalLength = AppData.designResolution.width + 14
        this.progressBar.barSprite.node.position = new cc.Vec2(-(this.progressBar.totalLength / 2), this.progressBar.barSprite.node.position.y)
        this.updatePercent(0)
    }

    public updateVersion(version ){

        if (version) {         
            this.versionLabel.string = "v:" + version;
        }        
    }

    public showTextLabel(content : string){

        this.textLabel.string = content;
    }

    public updatePercent(value : number){
        if (value > 1) {
            value = 1
        }

        this.progressBar.node.active = true;

        this.progressBar.progress = value;        
        
        this.barRightNode.position = new cc.Vec2(this.progressBar.barSprite.node.position.x + this.progressBar.totalLength * value,this.barRightNode.position.y);        
        // this.barRightNode.active = value > 0 ? true : false;        
    }
}
